import { Box, Typography } from '@mui/material';
import { useConfiguration } from './useConfiguration';
import { ConfigurationProps } from './types';
import { TemplateTabs } from './components/TemplateTabs/TemplateTabs';
import { InstrumentTypeTabs } from './components/InstrumentTypeTabs/InstrumentTypeTabs';
import { SectionRenderer } from './components/SectionRenderer/SectionRenderer';
import { AddTemplateDialog } from './components/AddTemplateDialog/AddTemplateDialog';
import { ExpandCollapseToggle } from './components/ExpandCollapseToggle/ExpandCollapseToggle';
import { ConfigurationSaveStatus } from './components/ConfigurationSaveStatus/ConfigurationSaveStatus';
import { useConfigurationAutoSave } from './hooks/useConfigurationAutoSave';
import './Configuration.scss';

export const Configuration = (props: ConfigurationProps) => {
  const {
    templates,
    activeTemplateId,
    activeInstrumentType,
    availableHeaders,
    visibleSections,
    handleTemplateSelect,
    handleAddTemplate,
    handleInstrumentTypeChange,
    isAddTemplateDialogOpen,
    handleCloseAddTemplateDialog,
    handleCreateTemplate,
    expandedSections,
    handleAccordionChange,
    handleExpandAll,
    handleCollapseAll,
  } = useConfiguration(props.initialTemplateId, props.isVisible);

  // Auto-save hook
  const saveStatus = useConfigurationAutoSave();

  return (
    <Box className="configuration">
      <TemplateTabs
        templates={templates}
        activeTemplateId={activeTemplateId}
        onTemplateSelect={handleTemplateSelect}
        onAddTemplate={handleAddTemplate}
      />

      <InstrumentTypeTabs
        activeInstrumentType={activeInstrumentType}
        onInstrumentTypeChange={handleInstrumentTypeChange}
      />

      <Box className="configurationSections">
        {activeTemplateId && activeInstrumentType && (
          <>
            <Box className="sectionsHeader">
              <ExpandCollapseToggle
                expandedSections={expandedSections}
                visibleSections={visibleSections}
                onExpandAll={handleExpandAll}
                onCollapseAll={handleCollapseAll}
              />
              <ConfigurationSaveStatus saveStatus={saveStatus} />
            </Box>
            <Box className="sectionsContent">
              {visibleSections.map(section => (
                <SectionRenderer
                  key={section.id}
                  section={section}
                  templateId={activeTemplateId}
                  instrumentType={activeInstrumentType}
                  availableHeaders={availableHeaders}
                  expanded={expandedSections.has(section.id)}
                  onChange={() => handleAccordionChange(section.id)}
                />
              ))}
            </Box>
          </>
        )}
      </Box>

      <AddTemplateDialog
        open={isAddTemplateDialogOpen}
        onClose={handleCloseAddTemplateDialog}
        onSubmit={handleCreateTemplate}
      />
    </Box>
  );
};
